import {
  DesignBranchingEvent,
  DesignBranchingEventType
} from '../../../types';

/** Get the latest branching event of the provided @see type. */
export function getLatestBranchingEvent<T extends DesignBranchingEventType>(
  branchingEvents: DesignBranchingEvent[] | undefined,
  type: T
): (DesignBranchingEvent & { type: T; }) | null;
export function getLatestBranchingEvent<T extends DesignBranchingEventType>(
  branchingEvents: DesignBranchingEvent[] | undefined,
  type: T[]
): (DesignBranchingEvent & { type: T; }) | null;
export function getLatestBranchingEvent(
  branchingEvents: DesignBranchingEvent[] | undefined,
  type: DesignBranchingEventType | DesignBranchingEventType[]
): DesignBranchingEvent | null {
  let latestEvent: DesignBranchingEvent | null = null;
  const types = new Set((type instanceof Array) ? type : [type]);
  branchingEvents?.forEach((event) => {
    if (
      types.has(event.type)
      && (!latestEvent || event.timestamp > latestEvent.timestamp)
    ) {
      latestEvent = event;
    }
  });

  return latestEvent;
}
